import { render, staticRenderFns } from "./content-video.vue?vue&type=template&id=1001d058&scoped=true"
import script from "./content-video.vue?vue&type=script&lang=js"
export * from "./content-video.vue?vue&type=script&lang=js"
import style0 from "./content-video.vue?vue&type=style&index=0&id=1001d058&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1001d058",
  null
  
)

export default component.exports